import { atom } from "recoil"
import { Key } from "../EnumKey"

const reverseResultAtom = atom({
  key: Key.REVERSERESULT,
  default: "" as string
})

export default reverseResultAtom